import { format } from "date-fns";
import {
  HbrCancel,
  HbrDeleteIcon,
  HbrIconFileCopy,
  HbrInfoIcon,
} from "../newComponents/Mycustomsvgicons";
import { useContext, useReducer, useState } from "react";
import { actionConsts, reducer } from "../newComponents/StateManager";
import { CustomAlertDialog } from "../newComponents/CustomAlertDialog";
import { AuthContext } from "../AuthContext";
import { ref, remove } from "firebase/database";
import { realTimeDB } from "../firebase";
import { sanitizeText } from "../newComponents/GeneralClasses";
import tvaxiosapi from "../api/tvaxiosapi";
import { ConstVariables } from "./ConstantVariables";

const Allschedule = ({
  startTime,
  endTime,
  videoTitle,
  videoThumbnail,
  videoUrl,
  id,
  handleUpdateDB,
  duration,
}) => {
  const [expandText, setExpandText] = useState(false);
  const [isImageClicked, setIsImageClicked] = useState(false);
  const [copied, setCopied] = useState(false);
  const [state, dispatch] = useReducer(reducer, {
    alertMessage: "",
    showAlert: false,
    progressIndicator: false,
  });
  const { user_email } = useContext(AuthContext);

  const handleCopyLink = async () => {
    if (navigator.clipboard) {
      try {
        await navigator.clipboard.writeText(videoUrl);
        setCopied(true);
        setTimeout(() => {
          setCopied(false);
        }, 2000);
        dispatch({ type: actionConsts.SHOWALERT, payload: true });
        dispatch({
          type: actionConsts.ALERT_MESSAGE,
          payload:
            "You have successfully copied the video url. Paste the copied link into the video Link field to republish the video",
        });
      } catch {}
    }
  };

  const handleDeleteVideoSchedule = async () => {
    dispatch({ type: actionConsts.PROGRESSINDICATOR, payload: true });
    const videodata = {
      videoid: id,
      useremail: user_email,
      api_key: ConstVariables.WEB_BOOKS_API_KEY,
    };

    try {
      const res = await tvaxiosapi.post(
        "/tvshows/deleteVideo",
        JSON.stringify(videodata),
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: false,
        }
      );
      dispatch({ type: actionConsts.SHOWALERT, payload: true });
      dispatch({
        type: actionConsts.ALERT_MESSAGE,
        payload: res?.data?.success,
      });
      handleUpdateDB();
      handleDeleteVidFromFirebase(videoTitle);
    } catch (error) {
      if (!error?.response) {
        dispatch({ type: actionConsts.SHOWALERT, payload: true });
        dispatch({
          type: actionConsts.ALERT_MESSAGE,
          payload: "Failed to delete schedule. something went wrong.",
        });
      } else if (error?.response) {
        dispatch({ type: actionConsts.SHOWALERT, payload: true });
        dispatch({
          type: actionConsts.ALERT_MESSAGE,
          payload: `Failed to delete schedule. ${error?.response?.data?.message}`,
        });
        console.error(error);
      }
    } finally {
      dispatch({ type: actionConsts.PROGRESSINDICATOR, payload: false });
    }
  };

  const handleDeleteVidFromFirebase = (video_Title) => {
    const childKey = sanitizeText(video_Title);
    remove(ref(realTimeDB, `TvShows/${childKey}`));
  };

  return (
    <div
      className="allschedule flex-row2"
      style={{
        width: "100%",
        background: "#101010",
        position: "relative",
        caretColor: "transparent",
      }}
    >
      {state.showAlert && (
        <CustomAlertDialog
          alertmessage={state.alertMessage}
          handleCloseDialog={() =>
            dispatch({ type: actionConsts.SHOWALERT, payload: false })
          }
          performAction={false}
        />
      )}

      <div
        style={{
          borderRight: "1px solid white",
          width: "20%",
          height: "100%",
          borderLeft: "1px solid white",
        }}
      >
        <pre
          style={{
            color: "white",
            fontSize: "0.8em",
            fontWeight: "bold",
            paddingLeft: "10px",
            whiteSpace: "pre-wrap",
          }}
        >
          {`${format(
            new Date(startTime),
            "yyyy-MM-dd hh:mm a"
          )} - \n \n ${format(new Date(endTime), "yyyy-MM-dd hh:mm a")}`}
        </pre>
      </div>

      <div
        className="flex-column1"
        style={{
          borderRight: "1px solid white",
          width: "60%",
          height: "100%",
          overflow: "hidden",
          whiteSpace: "nowrap",
          position: "relative",
          gap: "10px",
        }}
      >
        <p style={{ color: "white" }}>{videoTitle}</p>
        <HbrInfoIcon
          width={"1.7em"}
          height={"1.7em"}
          fillColour={"white"}
          handleClick={() => setExpandText((prev) => !prev)}
        />
        <p style={{ color: "white", fontWeight: "bold" }}>
          Duration: {duration}
        </p>

        <button
          onClick={() => handleCopyLink()}
          style={{
            color: "white",
            fontWeight: "bold",
            border: "none",
            backgroundColor: "transparent",
            cursor: "pointer",
          }}
        >
          {copied ? "link copied✔" : "Replicate"}{" "}
          <HbrIconFileCopy
            width={"1.7em"}
            height={"1.7em"}
            fillColour={"white"}
          />
        </button>

        <button
          style={{
            color: "white",
            fontWeight: "bold",
            border: "none",
            backgroundColor: "transparent",
            cursor: "pointer",
          }}
          onClick={() => handleDeleteVideoSchedule()}
        >
          Delete{" "}
          <HbrDeleteIcon
            width={"1.7em"}
            height={"1.7em"}
            fillColour={"white"}
          />
        </button>

        {state.progressIndicator && (
          <div
            style={{
              width: "50px",
              height: "50px",
              border: "5px solid black",
              borderBottom: "5px solid transparent",
              borderTop: "5px solid white",
              borderRadius: "50%",
              animation: "spin2 2s linear infinite",
            }}
          ></div>
        )}
      </div>

      <div
        style={{
          borderRight: "1px solid white",
          width: "20%",
          cursor: "pointer",
        }}
        onClick={() => setIsImageClicked(true)}
      >
        <img
          src={videoThumbnail}
          alt=""
          style={{
            width: "90%",
            height: "90%",
            padding: "10px",
            objectFit: "contain",
          }}
        />
      </div>

      {expandText && (
        <div
          className="flex-column2"
          style={{
            backgroundColor: "#252a41",
            borderRadius: "10px",
            position: "absolute",
            top: "50%",
            width: "300px",
            zIndex: "1",
            boxShadow:
              "0px 10px 20px rgba(0, 0, 0, 0.19), 0px 6px 6px rgba(0, 0, 0, 0.23)",
            padding: "10px",
          }}
        >
          <div
            style={{
              display: "flex",
              width: "100%",
              alignItems: "flex-end",
              justifyContent: "flex-end",
            }}
          >
            <HbrCancel
              width={"1.7em"}
              height={"1.7em"}
              fillColour={"white"}
              handleClick={() => setExpandText(false)}
            />
          </div>
          <p style={{ color: "white", fontWeight: "bold" }}>{videoTitle}</p>
          <img
            src={videoThumbnail}
            alt=""
            style={{ width: "100px", height: "100px", objectFit: "contain" }}
          />
        </div>
      )}

      {isImageClicked && (
        <div
          className="flex-column2"
          style={{
            backgroundColor: "#252a41",
            width: "70%",
            height: "70vh",
            borderRadius: "10px",
            position: "fixed",
            top: "10%",
            left: "20%",
            zIndex: "1",
            boxShadow:
              "0px 10px 20px rgba(0, 0, 0, 0.19), 0px 6px 6px rgba(0, 0, 0, 0.23)",
            padding: "10px",
          }}
        >
          <div
            style={{
              display: "flex",
              width: "100%",
              alignItems: "flex-end",
              justifyContent: "flex-end",
            }}
          >
            <HbrCancel
              width={"1.7em"}
              height={"1.7em"}
              fillColour={"white"}
              handleClick={() => setIsImageClicked(false)}
            />
          </div>
          <img
            src={videoThumbnail}
            alt=""
            style={{ width: "auto", height: "90%" }}
            onClick={() => setIsImageClicked(true)}
          />
        </div>
      )}
    </div>
  );
};
export default Allschedule;
